export default "__VITE_ASSET__ff3c05a7__"